import { DamEcoModeVersion, DamEcoPrimaryCondenser } from '~/providers/types/damEcoMode';

/** Faixa aceita pelo backend para os atrasos de estágio, em minutos inteiros. */
export const STAGE_DELAY_MIN = 0;
export const STAGE_DELAY_MAX = 29;

export const PRIMARY_CONDENSER_OPTIONS: { value: DamEcoPrimaryCondenser; labelKey: string }[] = [
  { value: 'COND1', labelKey: 'ecoSimplificadoCondensadora1' },
  { value: 'COND2', labelKey: 'ecoSimplificadoCondensadora2' },
];

/** Nome de cada modo eco, usado nas abas, na indicação do modo ativo e na alternância. */
export const ECO_MODE_LABEL_KEYS: Record<DamEcoModeVersion, string> = {
  LEGACY: 'ecoSimplificadoTelaModoAtual',
  SIMPLIFIED: 'ecoSimplificadoTelaModoSimplificado',
};
